module.exports = __webpack_public_path__ + "static/media/opencart.d2d8954a.svg";